import utc from 'dayjs/plugin/utc';
import dayjs from 'dayjs';
import { format } from 'path';

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT_DDBMMBYY = 'DD/MM/YY';
export const DATE_FORMAT_DBMBYYYY = 'D/M/YYYY';
export const HTML_DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const DATE_TIME_LONG_FORMAT = 'YYYY-MM-DDTHH:mm';
export const DATE_TIME_SEGUNDOS_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_ONLY_YEAR = 'YYYY';
export const DATE_ONLY_MONTH = 'MM';
export const DATE_ONLY_DAY = 'DD';
export const LOCALE = 'es-MX';
export const DATE_FORMAT_H = 'es-DD-MM-YYYY H:mm A';
export const AMERICA_MEXICO = 'America/Mexico_City';
export const ES_MX = 'es-MX';

export const formatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/Mexico_City',
});

import { formatRelative } from 'date-fns';
import { es } from 'date-fns/locale';

dayjs.extend(utc);

export function defaultFormat(date) {
  return dayjs(date).format(DATE_FORMAT);
}

export function fromMultiFormat(date) {
  let parseDate = dayjs(date, DATE_FORMAT);

  if (parseDate.isValid()) {
    return parseDate.format(HTML_DATE_FORMAT);
  } else {
    parseDate = dayjs(date, DATE_FORMAT_DDBMMBYY);

    if (parseDate.isValid()) {
      return parseDate.format(HTML_DATE_FORMAT);
    } else {
      parseDate = dayjs(date, DATE_FORMAT_DBMBYYYY);

      if (parseDate.isValid()) {
        return parseDate.format(HTML_DATE_FORMAT);
      }
    }
  }

  return null;
}

export function formatUtc(date) {
  return dayjs(date).isValid() ? dayjs(date).utc().format(DATE_FORMAT) : '';
}

export function formatUtcHtml(date) {
  return dayjs(date).isValid() ? dayjs(date).utc().format(HTML_DATE_FORMAT) : '';
}

export function formatDate(date) {
  return dayjs(date).format(DATE_TIME_FORMAT);
}

export function formatDateHoraSegundos(date) {
  return dayjs(date).format(DATE_TIME_SEGUNDOS_FORMAT);
}

export function duration(date) {
  if (date) {
    const formatted = dayjs.duration(date).humanize();
    if (formatted) {
      return formatted;
    }
    return date;
  }
  return '';
}

export function timeElapsed(date) {
  if (date) {
    return formatRelative(new Date(date), new Date(), { locale: es });
  }
  return '';
}

export function formatAndValidateDate(date) {
  if (!date) {
    return '';
  }

  //TODO Pasar esta expresión a la configuración de una solución y no dejar en código duro, ver sección Cómo agregar columnas dinámicamente en la documentación del ápeiron
  const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
  return regex.test(date.toString()) ? formatUtc(date) : date;
}

export function stringDateInUtcComparator(leftDateString, rightDateString) {
  return new Date(leftDateString).getTime() - new Date(rightDateString).getTime();
}

export function formatDateYear(date) {
  return dayjs(date).format(DATE_ONLY_YEAR);
}

export function formatUtcMx(date) {
  return dayjs(date).isValid() ? dayjs(date).utc().subtract(6, 'hours').format(DATE_FORMAT) : '';
}

export function formatDateTimeUtcMx(date) {
  return dayjs(date).isValid() ? dayjs(date).utc().subtract(6, 'hours').format(DATE_TIME_FORMAT) : '';
}

export function obtenerFechaHoyYYYYMMDD(): string {
  return dayjs(new Date()).format(HTML_DATE_FORMAT);
}

/**
 * Da formato a los selectores de fecha.
 * @returns regresa el formato para que se muestre DD/MM/YYYY
 */
export const FORMATO_DATE_PICKER = { year: 'numeric', month: 'numeric', day: 'numeric' };

/**
 * Regresa el primer día de mes a partir de la fecha indicada.
 *
 * @param fecha Fecha indicada en formato YYYY-MM-DD
 * @returns Fecha con el primer día de mes en formato YYYY-MM-DD
 */
export function obtenerFechaPrimerDiaMes(fecha: string): string {
  const elementos = fecha.split('-').map(Number);
  const primerDiaMes = new Date(elementos[0], elementos[1] - 1, 1);
  return formatUtc(primerDiaMes);
}

/**
 * Regresa el último día de mes más los meses indicados en formato YYYY-MM-DD.
 *
 * @param fecha Fecha indicada en formato YYYY-MM-DD
 * @param meses Cantidad de meses a sumar a la fecha.
 * @returns Fecha con el último día de mes y con los meses sumados.
 */
export function obtenerFechaMasMesesUltimoDiaMes(fecha: string, meses: number): string {
  let elementos = fecha.split('-').map(Number);
  const fechaInicial = new Date(elementos[0], elementos[1] - 1, elementos[2]);
  const fechaFinal = formatUtcHtml(dayjs(fechaInicial).utc().add(meses, 'months'));
  elementos = fechaFinal.split('-').map(Number);
  return formatUtc(new Date(elementos[0], elementos[1] - 1, 0));
}
